import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { GuideSteps, Eyebrow, NumberRow } from './guideStepPrimitives';
import { GATEWAY_NUMBER_DISPLAY } from './wooriGuide';
import { KB_REGISTER_STEPS, KB_NOTIFY_OPTIONS } from './kbGuide';

interface Props {
  registered: boolean;               // Type B 미사용(soft 신호 없음). 시그니처 통일용.
  onCancel: () => void;
  onComplete: () => void;
}

export function KBRegistrationGuide({ onCancel, onComplete }: Props) {
  const [acked, setAcked] = useState(false);
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Eyebrow>KB 인터넷뱅킹 ‘통지매체번호’에 입력</Eyebrow>
        <NumberRow label="입출금 통지 SMS를 받을 번호" value={GATEWAY_NUMBER_DISPLAY} />
        <p className="rounded-lg bg-amber-50 px-3 py-2 text-xs font-medium ring-1 ring-amber-100">
          <span className="block text-amber-800">내 휴대폰 번호를 입력하면 자동 매칭이 작동하지 않아요.</span>
          <span className="mt-1 block font-semibold text-rose-600">
            내 휴대폰 번호가 아니라 {GATEWAY_NUMBER_DISPLAY}를 입력해주세요.
          </span>
        </p>
      </div>

      <div className="space-y-3">
        <Eyebrow>KB 인터넷뱅킹(PC)에서 따라하기</Eyebrow>
        <GuideSteps steps={KB_REGISTER_STEPS} startAt={1} />
      </div>

      <div className="rounded-xl bg-slate-50 p-4 ring-1 ring-slate-100">
        <Eyebrow>통지 옵션</Eyebrow>
        <GuideSteps steps={KB_NOTIFY_OPTIONS} startAt={1} />
      </div>

      <div className="rounded-2xl border border-slate-100 bg-slate-50/60 px-5 py-4">
        <label className="flex cursor-pointer items-start gap-2.5 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={acked}
            onChange={(e) => setAcked(e.target.checked)}
            className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 text-teal-600 focus:ring-teal-500/40"
          />
          <span>
            KB 인터넷뱅킹에서 <b>[등록]</b>과 ARS 본인인증까지 마쳤어요.
          </span>
        </label>
      </div>

      <div className="space-y-2 border-t border-slate-100 pt-4">
        <div className="flex gap-2.5">
          <Button variant="outline"
            className="h-11 flex-1 rounded-xl border-slate-200 font-medium text-slate-600 hover:bg-slate-50"
            onClick={onCancel}>
            취소
          </Button>
          <Button
            className={cn('h-11 flex-1 rounded-xl bg-teal-600 font-semibold text-white shadow-sm transition-colors hover:bg-teal-700 disabled:opacity-50')}
            onClick={onComplete}
            disabled={!acked}>
            등록 완료했어요
          </Button>
        </div>
        {!acked && (
          <p className="text-center text-xs text-slate-400">
            위 항목을 확인하면 완료 버튼이 활성화돼요.
          </p>
        )}
      </div>
    </div>
  );
}
